/* eslint-disable no-unused-vars */
import { TextInput } from '@components';
import { beneficiarioSchema } from '@schemas';
import { PLANO_TAESA } from '@utils/plans';
import { Field, Form, Formik } from 'formik';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

export const Beneficiario = ({ beneficiario, index, onChangeBeneficiario }) => {
  const numeroPlano = useSelector((state) => state.user.plano);
  const mostraParentesco = numeroPlano !== PLANO_TAESA;
  const mostraSituacao = beneficiario.situacao === 'Inválido';

  const [exibirDetalhes, setExibirDetalhes] = useState(false);

  const initialValues = {
    nome: beneficiario.nome,
    nascimento: beneficiario.nascimento,
    parentesco: beneficiario.parentesco,
    situacao: beneficiario.situacao,
  };

  const onChangeForm = (formValues) => {
    onChangeBeneficiario(formValues, index);
  };

  const handleVerMaisClick = () => {
    setExibirDetalhes((prev) => !prev);
  };

  return (
    <div className="card mb-32" key={index}>
      <p className="mb-32 text-muted ts-14">Beneficiários para fim de pensão</p>

      <Formik
        initialValues={initialValues}
        validationSchema={beneficiarioSchema}
        validate={onChangeForm}
      >
        {() => (
          <Form>
            <div className="row">
              <div className="col-md-12 col-lg-6">
                <Field
                  className="mb-2"
                  name="nome"
                  component={TextInput}
                  disabled
                  label="Nome completo"
                />
              </div>
              <div className="col-md-12 col-lg-6">
                {mostraParentesco && (
                  <Field
                    className="mb-3"
                    name="parentesco"
                    component={TextInput}
                    disabled
                    label="Parentesco/Vínculo"
                  />
                )}
              </div>
            </div>

            {exibirDetalhes && (
              <div className="row">
                <div className="col-md-12 col-lg-6">
                  <Field
                    className="mb-3"
                    name="nascimento"
                    component={TextInput}
                    disabled
                    label="Nascimento"
                  />
                </div>

                <div className="col-md-12 col-lg-6">
                  {mostraSituacao && (
                    <Field
                      className="mb-3"
                      name="situacao"
                      component={TextInput}
                      disabled
                      label="Situação"
                    />
                  )}
                </div>
              </div>
            )}
            <div className="text-center pt-2">
              <button
                type="button"
                className="text-orange ts-16 "
                onClick={handleVerMaisClick}
                style={{
                  all: 'unset',
                  cursor: 'pointer',
                }}
              >
                {exibirDetalhes ? 'Ver menos' : 'Mostrar detalhes'}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};
